export default __webpack_public_path__ + "static/media/messages.4cf30702b33ce833ec231113dfd8b821.svg";